import React, { useState, useRef, useCallback, useEffect } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import ReactCrop, { centerCrop, makeAspectCrop, Crop, PixelCrop } from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

type Props = {
  setData?: any
}

export const ReactCropper: React.FC<Props> = ({
  setData,
}) => {
  const [imgSrc, setImgSrc] = useState('')
  const imgRef = useRef<HTMLImageElement>(null)
  const [crop, setCrop] = useState<Crop>()
  const [scale, setScale] = useState(1)
  const [rotate, setRotate] = useState(0)
  const [aspect, setAspect] = useState<number | undefined>(1)

  function onSelectFile(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined) // Makes crop preview update between images.
      const reader = new FileReader()
      reader.addEventListener('load', () => setImgSrc(reader.result?.toString() || ''))
      reader.readAsDataURL(e.target.files[0])
    }
  }

  function centerAspectCrop(mediaWidth: number, mediaHeight: number, aspect: number) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 100,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    )
  }

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    if (aspect) {
      const { width, height } = e.currentTarget
      setCrop(centerAspectCrop(width, height, aspect))
    }
  }

  function handleToggleAspectClick(event: React.FormEvent<HTMLSelectElement>) {
    var aspectValue: string = event.currentTarget.value;
    if (aspectValue === '') {
      setAspect(undefined)
    } else if (imgRef.current) {
      var parsedAspectValue: number = 1
      switch (aspectValue) {
        case '169': parsedAspectValue = 16 / 9; break;
        case '916': parsedAspectValue = 9 / 16; break;
        case '43': parsedAspectValue = 4 / 3; break;
        case '34': parsedAspectValue = 3 / 4; break;
        default: parsedAspectValue = 1; break;
      }

      const { width, height } = imgRef.current
      setAspect(parsedAspectValue)
      setCrop(centerAspectCrop(width, height, parsedAspectValue))
    }
  }

  const [previewUrl, setPreviewUrl] = useState('');

  const cropImage = async (pixelCrop: PixelCrop) => {
    // setCompletedCrop(pixelCrop);
    if (imgRef.current && pixelCrop?.width && pixelCrop?.height) {
      const canvas = document.createElement('canvas');
      const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
      const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        throw new Error('No 2d context')
      }

      ctx.drawImage(
        imgRef.current,
        pixelCrop.x * scaleX,
        pixelCrop.y * scaleY,
        pixelCrop.width * scaleX,
        pixelCrop.height * scaleY,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      // var image2 = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
      // window.location.href = image2;

      setData(canvas.toDataURL('image/jpeg'))
    }
  };

  return (
    <div className="App">
      <div className="Crop-Controls">
        <div className='row mb-6'>
          <div className='col-lg-8 fv-row'>
            <input type="file" accept="image/png,image/jpeg,image/jpg" onChange={onSelectFile} />
          </div>
        </div>

        {!!imgSrc && (
          <div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Zoom')}</label>
              <div className='col-lg-8 fv-row'>
                <input
                  placeholder={LanguageHelp('Text')}
                  name='text'
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  autoComplete='off'
                  id="scale-input"
                  type="number"
                  step="0.1"
                  value={scale}
                  disabled={!imgSrc}
                  onChange={e => setScale(Number(e.target.value))}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Rotate')}</label>
              <div className='col-lg-8 fv-row'>
                <input
                  placeholder={LanguageHelp('Text')}
                  name='text'
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  autoComplete='off'
                  id="rotate-input"
                  type="number"
                  value={rotate}
                  disabled={!imgSrc}
                  onChange={e => setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))}
                />
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>{LanguageHelp('Screeen Ratio')}</label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  defaultValue={''}
                  onChange={e => handleToggleAspectClick(e)}
                >
                  <option value=''>{LanguageHelp('Dynamic')}</option>
                  <option value='1'>1/1</option>
                  <option value='169'>16/9</option>
                  <option value='916'>9/16</option>
                  <option value='43'>4/3</option>
                  <option value='34'>3/4</option>
                </select>
              </div>
            </div>
            <ReactCrop
              crop={crop}
              onChange={(_, percentCrop) => setCrop(percentCrop)}
              onComplete={c => cropImage(c)}
              aspect={aspect}
            >
              <img
                ref={imgRef}
                alt="Crop me"
                src={imgSrc}
                style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                onLoad={onImageLoad}
              />
            </ReactCrop>
          </div>
        )}
      </div>
    </div>
  )
}

